import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Home from "./pages/Home";
import "./styles/index.css";

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Redirect exact from="/" to="/Home"></Redirect>
          <Route path="/home" component={Home}></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
